import Tr from 'translations/Translations';

export const AdditionalRoundStatus = {
    OFFER_COLLECTION: 'OFFER_COLLECTION',
    OFFER_DECRYPTION: 'OFFER_DECRYPTION',
    OFFER_EVALUATION: 'OFFER_EVALUATION',
    CANCELLED: 'CANCELLED',
    FINISHED: 'FINISHED'
}

export const LABELS = {
    [AdditionalRoundStatus.OFFER_COLLECTION]: Tr('procedure_status_2'),
    [AdditionalRoundStatus.OFFER_DECRYPTION]: Tr('procedure_status_4_0'),
    [AdditionalRoundStatus.OFFER_EVALUATION]: Tr('procedure_status_4'),
    [AdditionalRoundStatus.FINISHED]: Tr('procedure_status_7'),
    [AdditionalRoundStatus.CANCELLED]: Tr('procedure_status_6'),
}

export const AdditionalRoundStatusLabel = (status) => (LABELS[status]);

export const AdditionalRoundStatusesPending = [AdditionalRoundStatus.OFFER_COLLECTION, AdditionalRoundStatus.OFFER_DECRYPTION]
